import React from "react";
import "./summercampsblock.css"; // if you have styling

const SummerCampsBlock = ({
  image,
  name,
  description,
  order,
  specialHeading,
}) => {
  return (
    <div className={`summercampsblock-ss-block-ui ${order}`}>
      {/* Image */}
      <div className="ssb-img">
        {/* <img src={image} alt={name} /> */}
        <img src={image} title={name} />
      </div>

      {/* Content */}
      <div className="ssb-cnt">
        <div className="ssb-title">
          <h2 className="text-clip">{name}</h2>
        </div>

        <div className="ssb-desc">
          {description.map((i) => (
            <p className="text-clip" style={{ marginBottom: "20px" }}>
              {i}
            </p>
          ))}
        </div>

        <div className="ssb-desc special-heading">
          <span
            className="text-clip"
            style={{ marginBottom: "20px", marginTop: "40px" }}
          >
            {specialHeading}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SummerCampsBlock;
